// extracted by mini-css-extract-plugin
module.exports = {"root":"PublishButton_root__GrIl0"};